import React, { useEffect, useRef, useState } from "react";
import "../../global.css";
import "./textualNarratives.css";
import { useMediaQuery } from "react-responsive";
import { setContent, setIsOpenContentsModal } from "../../redux/contentSlice";
import { useSelector, useDispatch } from "react-redux";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import ContentCard from "../../components/contentcard/ContentCard";
import { FaArrowRight } from "react-icons/fa";
import DetailsModal from "../../components/detailsmodal/DetailsModal";
import { useTranslate } from "../../utils/useTranslate";

const TextualNarratives = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [isShowAll, setIsShowAll] = useState(false);

  const [selectedFileName, setSelectedFileName] = useState(null);

  const { language } = useSelector((state) => state.language);

  const [contents, setContents] = useState([]);
  const [otherContents, setOtherContents] = useState([]);

  const [contentDatas, setContentDatas] = useState([]);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    } else {
      fetch("/assets/datas/tr-contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    }
  }, [language]);

  const { content, isOpenContentsModal } = useSelector(
    (state) => state.content
  );

  useEffect(() => {
    dispatch(setContent(contents[2]));
    setOtherContents(contents.filter((x) => x.id !== Number(contents[2].id)));
    setContentDatas(contents[2]?.datas);
  }, [contents, dispatch]);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="globalContainer textualNarrativesContainer"
      style={{ paddingBottom: open === true && "145px" }}
    >
      {selectedFileName !== null && (
        <DetailsModal
          isOpen={true}
          onClose={() => setSelectedFileName(null)}
          fileName={selectedFileName}
        />
      )}
      <div
        className="textualNarrativesLeftContainer"
        style={{
          width: isOpenContentsModal === false && isMobile === false && "96%",
        }}
      >
        <div className="textualNarrativesLeftSubContainer">
          <div className="textualNarrativesLeftSubAltContainer">
            <span className="textFlex textualNarrativesTitleStyle">
              {language.value === "tr"
                ? content?.title.toLocaleUpperCase("tr-TR")
                : content?.title.toLocaleUpperCase("en-US")}
            </span>
            <span className="textMono textualNarrativesSubTitleStyle">
              {content?.subTitle}
            </span>
          </div>
          <span className="textFlex textualNarrativesDescriptionStyle">
            {content?.description}
          </span>
        </div>
        {isShowAll === true && (
          <div
            style={{
              width: "100%",
              height: "35px",
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <button
              className="textMono"
              style={{
                padding: "5px 20px",
                backgroundColor: "#ef4536",
                fontWeight: "bold",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                setContentDatas(content?.datas);
                setIsShowAll(false);
              }}
            >
              {language.value === "tr"
                ? translate("showAll").toLocaleUpperCase("tr-TR")
                : translate("showAll").toLocaleUpperCase("en-US")}
            </button>
          </div>
        )}
        <div className="textualNarrativesLeftBottomContainer">
          {contentDatas?.map((item, index) => (
            <div
              key={item.id}
              style={{
                marginBottom: "20px",
                width: "100%",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent:
                  isMobile === false ? "space-between" : "flex-start",
                flexDirection: isMobile === false ? "row" : "column",
                border: isMobile === false && "1px solid #100F0D",
                minHeight: "444px",
                gap: "20px",
                backgroundColor: isMobile === false && "#ffffff",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <img
                  style={{
                    maxWidth: isMobile === false && "540px",
                    maxHeight: "450px",
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                  }}
                  alt=""
                  src={`/assets/images/${item?.image}`}
                />
              </div>
              <div
                style={{
                  minHeight: "309px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  gap: "20px",
                  marginTop: isMobile === false && "20px",
                  marginBottom: isMobile === false && "20px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    minHeight: "52px",
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <span
                    className="textFlex"
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                    }}
                  >
                    {language.value === "tr"
                      ? item?.title.toLocaleUpperCase("tr-TR")
                      : item?.title.toLocaleUpperCase("en-US")}
                  </span>
                  <button
                    style={{
                      padding: "10px",
                      borderRadius: "3px",
                      height: "24px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "fit-content",
                      border: "1px solid #100F0D",
                      backgroundColor:
                        item?.tagColor === "" || item?.tagColor === undefined
                          ? "#fffff"
                          : `${item?.tagColor}`,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const newDatas = content?.datas.filter(
                        (x) => x.tagName === item.tagName
                      );
                      setContentDatas(newDatas);
                      setIsShowAll(true);
                    }}
                  >
                    <span
                      className="textMono"
                      style={{
                        fontWeight: "700",
                        fontSize: "12px",
                        color: "#100F0D",
                        textTransform: "uppercase",
                      }}
                    >
                      {item?.tagName}
                    </span>
                  </button>
                </div>
                <div
                  style={{
                    width: "100%",
                    minHeight: "40px",
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <span
                    className="textMono"
                    style={{
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "140%",
                    }}
                  >
                    {language.value === "tr"
                      ? translate("language").toLocaleUpperCase("tr-TR")
                      : translate("language").toLocaleUpperCase("en-US")}
                    :
                  </span>
                  <span
                    className="textFlex"
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "140%",
                      textTransform: "uppercase",
                    }}
                  >
                    {item?.language}
                  </span>
                  <span
                    className="textMono"
                    style={{
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "140%",
                    }}
                  >
                    {language.value === "tr"
                      ? translate("writer").toLocaleUpperCase("tr-TR")
                      : translate("writer").toLocaleUpperCase("en-US")}
                    :
                  </span>
                  <span
                    className="textFlex"
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "140%",
                      textTransform: "uppercase",
                    }}
                  >
                    {language.value === "tr"
                      ? item?.writer.toLocaleUpperCase("tr-TR")
                      : item?.writer.toLocaleUpperCase("en-US")}
                  </span>
                  <span
                    className="textMono"
                    style={{
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "140%",
                    }}
                  >
                    {language.value === "tr"
                      ? translate("translator").toLocaleUpperCase("tr-TR")
                      : translate("translator").toLocaleUpperCase("en-US")}
                    :
                  </span>
                  <span
                    className="textFlex"
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "140%",
                    }}
                  >
                    {language.value === "tr"
                      ? item?.translator.toLocaleUpperCase("tr-TR")
                      : item?.translator.toLocaleUpperCase("en-US")}
                  </span>
                  <span
                    className="textMono"
                    style={{
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "140%",
                    }}
                  >
                    {language.value === "tr"
                      ? translate("publisher").toLocaleUpperCase("tr-TR")
                      : translate("publisher").toLocaleUpperCase("en-US")}
                    :
                  </span>
                  <span
                    className="textFlex"
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "140%",
                    }}
                  >
                    {language.value === "tr"
                      ? item?.publisher.toLocaleUpperCase("tr-TR")
                      : item?.publisher.toLocaleUpperCase("en-US")}
                  </span>
                </div>
                <span
                  className="textFlex"
                  style={{
                    width: "100%",
                    maxWidth: isMobile === false && "440px",
                    minHeight: "102px",
                    fontWeight: "400",
                    fontSize: "12px",
                    lineHeight: "140%",
                  }}
                >
                  {item?.description}
                </span>
                <hr
                  style={{
                    width: "95%",
                    marginLeft: "-0px",
                    border: "1px solid #100F0D80",
                  }}
                />
                <div
                  style={{
                    width: "95%",
                    marginLeft: "-0px",
                    minHeight: isMobile === false && "35px",
                    height: "100%",
                    display: "flex",
                    alignItems: isMobile === false && "center",
                    justifyContent:
                      isMobile === true ? "flex-start" : "space-between",
                    flexDirection: isMobile === true && "column",
                    gap: isMobile === true && "20px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      minHeight: "19px",
                      height: "100%",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="dropdown"
                      style={{
                        zIndex: "10",
                        width: isMobile === false ? "60%" : "100%",
                      }}
                      ref={dropdownRef}
                    >
                      <button
                        className="dropdown-btn textMono"
                        onClick={() => setOpen(!open)}
                      >
                        {language.value === "tr"
                          ? translate("buyingOptions").toLocaleUpperCase(
                              "tr-TR"
                            )
                          : translate("buyingOptions").toLocaleUpperCase(
                              "en-US"
                            )}{" "}
                        ▼
                      </button>

                      {open && (
                        <div className="dropdown-menu">
                          {item?.buyingOptions.map((option, idx) => (
                            <div
                              key={idx}
                              className="dropdown-item"
                              style={{
                                borderBottom: "1px solid black",
                              }}
                              onClick={() =>
                                window.open(
                                  option.link,
                                  "_blank",
                                  "noopener,noreferrer"
                                )
                              }
                            >
                              <img
                                style={{ height: "25px" }}
                                alt=""
                                src={`/assets/images/${option.image}`}
                              />
                              <span
                                className="textFlex"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                }}
                              >
                                {option.platform}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {item?.fileName !== undefined && (
                    <>
                      <button
                        style={{
                          maxWidth: "138px",
                          width: "100%",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedFileName(item.fileName)}
                      >
                        <span
                          className="textMono"
                          style={{ fontWeight: "700", fontSize: "14px" }}
                        >
                          {language.value === "tr"
                            ? translate("readUs").toLocaleUpperCase("tr-TR")
                            : translate("readUs").toLocaleUpperCase("en-US")}
                        </span>
                        <FaArrowRight
                          style={{ fontSize: "9px", color: "#100F0D" }}
                        />
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isOpenContentsModal === true && isMobile === false ? (
        <div className="textualNarrativesRightContainer">
          <div className="textualNarrativesRightSubContainer">
            <span className="textMono otherContentTextStyle">
              {language.value === "tr"
                ? translate("otherContents").toLocaleUpperCase("tr-TR")
                : translate("otherContents").toLocaleUpperCase("en-US")}
            </span>
            <hr className="textualNarrativesRightDivHr" />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              gap: "10px",
            }}
          >
            {otherContents.map((item) => (
              <ContentCard
                item={item}
                isHome={false}
                isMobile={false}
                key={item.id}
              />
            ))}
          </div>
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("otherContents").toLocaleUpperCase("tr-TR")
                  : translate("otherContents").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : isMobile === true && isOpenContentsModal === false ? (
        <div className="homeRightContainer">
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
              onClick={() => dispatch(setIsOpenContentsModal(true))}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("otherContents").toLocaleUpperCase("tr-TR")
                  : translate("otherContents").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : (
        isMobile === true &&
        isOpenContentsModal === true && (
          <div className="customModalOverlay">
            <div className="customModalContainer">
              <div
                className="homeRightContainer"
                style={{
                  height: "70vh",
                }}
              >
                <div className="homeRightSubContainer">
                  <span className="textMono allContentTextStyle">
                    {language.value === "tr"
                      ? translate("otherContents").toLocaleUpperCase("tr-TR")
                      : translate("otherContents").toLocaleUpperCase("en-US")}
                  </span>
                  <hr className="homeRightDivHr" />
                </div>
                <div className="modalScrollableContent">
                  {otherContents.map((item) => (
                    <ContentCard
                      item={item}
                      isHome={false}
                      isMobile={true}
                      key={item.id}
                    />
                  ))}
                </div>

                {isMobile && (
                  <button
                    className="allContentMobileStyle"
                    style={{ textDecoration: "none" }}
                    onClick={() => dispatch(setIsOpenContentsModal(false))}
                  >
                    <IoCloseOutline
                      style={{ fontSize: "18px", color: "#100F0D" }}
                    />
                    <span className="linkTextStyle textMono">
                      {language.value === "tr"
                        ? translate("otherContents").toLocaleUpperCase("tr-TR")
                        : translate("otherContents").toLocaleUpperCase("en-US")}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default TextualNarratives;
